<section class="no-project-access">
  <h1 class="no-project-access__title">No project access</h1>
  <p class="no-project-access__message">
    Your user could not be loaded with project access. This usually means your account is missing project assignment.
  </p>
  <p class="no-project-access__message">
    Contact your completion administrator or service desk to restore access.
  </p>

  <div class="no-project-access__actions">
    <a pButton severity="warn" routerLink="/dashboard">Try again</a>
  </div>
</section>

